import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from '@/components/ui/carousel'
import { GuideMainTopics } from '@app/components/Guide/types/guide.types'
import { GuideCard } from '@app/modules/GuideV2/components/GuideCard'
import SectionContent from '../../../../src/components/SectionContent'
import SectionHeading from '../../HomeV2/components/SectionHeading'

import { appLink } from '@app/config/appLink'
import { useNavigate } from 'react-router-dom'
import { useTutorialsAndDemos } from '../hooks/useTutorialsAndDemos'
import { GuideCardSkeleton } from './GuideCardSkeleton'

export const GuideRecentTutorials = () => {
  const { data: tutorialsAndDemos = [], isLoading } = useTutorialsAndDemos()
  const navigate = useNavigate()

  return (
    <div className="py-2">
      <SectionContent>
        <SectionHeading>Recent tutorials and demos</SectionHeading>
        <Carousel opts={{ align: 'start', loop: false }} className="w-full max-w-5xl mx-auto">
          <CarouselContent className="-ml-4">
            {isLoading
              ? Array.from({ length: 3 }).map((_, index) => (
                  <CarouselItem key={index} className="pl-4 md:basis-1/2 lg:basis-1/3">
                    <GuideCardSkeleton />
                  </CarouselItem>
                ))
              : tutorialsAndDemos.map((tutorial) => (
                  <CarouselItem key={tutorial.id} className="pl-4 md:basis-1/2 lg:basis-1/3">
                    <GuideCard
                      title={tutorial.title}
                      description={tutorial.summary ?? ''}
                      type={tutorial.contentType}
                      onActionClick={() => {
                        const subTabSlug = tutorial.sub_tabs?.[0]?.slug
                        const slug =
                          tutorial.contentType === GuideMainTopics.DEMOS
                            ? tutorial.Slug // TODO: fix it from strapi api to be consistent with tutorials (lowercase 'slug' field)
                            : tutorial.slug

                        navigate(
                          `${appLink.guidePage.path}/${tutorial.contentType}/${subTabSlug}/${slug}`,
                        )
                      }}
                    />
                  </CarouselItem>
                ))}
          </CarouselContent>
          <CarouselPrevious className="-left-4 lg:-left-10 rounded-md" size={'icon'} />
          <CarouselNext className="-right-4 lg:-right-10 rounded-md" size={'icon'} />
        </Carousel>
      </SectionContent>
    </div>
  )
}
